module.exports = __webpack_public_path__ + "static/media/points-portal6.8df364ad.8df364ad.JPG";